/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 Open Assessment Technologies SA;
 */

const placeholderRegExp = /(\{\{[\w\-_.]+\}\})+?/;

/**
 * Check if there is an element placeholder in the input string
 * A placeholder is identified by {{element_id}}
 *
 * @param {String} inputString
 * @returns {Boolean} true if the input contains one or more placeholders
 */
export function hasPlaceholder(inputString) {
    return placeholderRegExp.test(inputString);
}

/**
 * Extracts element placeholder from a string,
 * along with the surrounding content.
 *
 * @example extractPlaceholderContent('Before content {{foo_1}} middle content {{bar_12}} after content');
 * returns ['Before content ', '{{foo_1}}', ' middle content ', '{{bar_12}}', ' after content']
 *
 * @param {String} inputString
 * @returns {Boolean} true if the input contains one or more placeholders
 */
export function extractPlaceholderContent(inputString) {
    return inputString.split(placeholderRegExp).filter(Boolean);
}
